import React, {useMemo} from 'react';

import AuditLogFilterDropdown from './AuditLogFilterDropdown';
import AuditLogMultiSelectFilterDropdownContent, {
  AuditLogFilterOption,
} from './AuditLogMultiSelectFilterDropdown';

export interface AuditLogReasonCodeFilterDropdownProps {
  reasonCodes: Array<string>;
  selectedReasonCodes: Array<string>;
  onChange: (selectedReasonCodes: Array<string>) => void;
  disabled?: boolean;
}

function reasonCodeToOption(reasonCode: string): AuditLogFilterOption {
  return {
    value: reasonCode,
    label: reasonCode,
  };
}

const LABEL = 'Reason Code';

export default function AuditLogReasonCodeFilterDropdown(
  props: AuditLogReasonCodeFilterDropdownProps
): JSX.Element {
  const {reasonCodes, selectedReasonCodes, onChange, disabled} = props;
  const options = useMemo(() => reasonCodes.map((rc) => reasonCodeToOption(rc)), [reasonCodes]);

  const hasNoOptions = reasonCodes.length === 0;

  return (
    <AuditLogFilterDropdown
      label={LABEL}
      count={selectedReasonCodes.length}
      disabled={disabled || hasNoOptions}
      tooltipTitle={hasNoOptions ? 'No reason codes in current audit log' : undefined}
      content={
        <AuditLogMultiSelectFilterDropdownContent<AuditLogFilterOption>
          options={options}
          selectedValues={selectedReasonCodes}
          onChange={onChange}
        />
      }
    />
  );
}
